import {
  ActionIcon,
  Divider,
  Group,
  Menu,
  NumberFormatter,
  Paper,
  RingProgress,
  Stack,
  Text,
  ThemeIcon,
  Tooltip,
} from "@mantine/core";
import LoaderStats from "../LoaderStats";
import {
  IconCheck,
  IconClick,
  IconDots,
  IconEye,
  IconMessage,
  IconUserPlus,
} from "@tabler/icons-react";
import ReportingInfo from "../ReportingInfo";
import { useLanguage } from "../../../../stores/LanguageStore";

function handleConclusion(rate) {
  if (rate >= 5) {
    return "green.6";
  } else if (rate >= 2) {
    return "orange";
  }
  return "red";
}

const TypeSummary = ({
  icon,
  title,
  sent,
  answers,
  rate,
  color,
  withRate = true,
  setIsGlobal,
  isGlobal,
  info,
  withOpener,
  opens,
  withClicks,
  clicks,
  isLinkedin,
  isUnique,
}) => {
  const lang = useLanguage((s) => s.language);
  return (
    <Paper
      component={Stack}
      flex={1}
      p={"lg"}
      style={{ alignSelf: "stretch", boxShadow: "#00000016 0px 1px 4px" }}
      bg={"#fcfbff"}
      pos={"relative"}
    >
      {setIsGlobal && (
        <Menu>
          <Menu.Target>
            <ActionIcon
              variant="subtle"
              size={"xl"}
              pos={"absolute"}
              top={8}
              right={8}
            >
              <IconDots size={32} />
            </ActionIcon>
          </Menu.Target>

          <Menu.Dropdown>
            <Menu.Item onClick={() => setIsGlobal(!isGlobal)}>
              <Group justify="end">
                {isGlobal && <IconCheck />}
                <Text size="md">{lang.reports.base_engaged}</Text>
              </Group>
            </Menu.Item>
            <Menu.Item onClick={() => setIsGlobal(!isGlobal)}>
              <Group justify="end">
                {!isGlobal && <IconCheck />}
                <Text size="md">{lang.reports.base_sent}</Text>
              </Group>
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      )}

      <LoaderStats isDate isProgStats />
      <Group>
        <ThemeIcon variant="filled" radius={"md"} size={"lg"} color={color}>
          {icon}
        </ThemeIcon>
        <Text size="lg" fw={600}>
          {title}
        </Text>
        <ReportingInfo>{info}</ReportingInfo>
      </Group>

      <Divider w={"100%"} color="gray.2" />

      <Stack>
        <Group>
          <Stack
            flex={"1 1 auto"}
            fz={22}
            style={{ borderRadius: 12 }}
            wrap={"nowrap"}
            fw={600}
            gap={0}
            px={16}
            mr={16}
          >
            <NumberFormatter value={sent} thousandSeparator=" " />
            <Text size="md">{lang.reports.sending}</Text>
          </Stack>

          {withRate && (
            <Tooltip label={lang.reports.answers}>
              <Stack
                align="center"
                flex={"1 1 auto"}
                bg={color}
                fz={18}
                style={{ borderRadius: 12, border: `1px solid ${color}` }}
                wrap={"nowrap"}
                c={"#fcfbff"}
                fw={600}
                gap={4}
                py={8}
                px={12}
                ta={"right"}
              >
                <Group>
                  <IconMessage />

                  <NumberFormatter value={answers} thousandSeparator=" " />
                </Group>
                {isUnique && <Text size="md">{lang.reports.unique}</Text>}
              </Stack>
            </Tooltip>
          )}
        </Group>
        <Group>
          {withOpener && (
            <Tooltip
              label={
                isLinkedin
                  ? lang.reports.accepted_invitations
                  : lang.reports.opens
              }
            >
              <Stack
                align="center"
                flex={"1 1 auto"}
                fz={18}
                style={{
                  borderRadius: 12,
                  border: `1px solid var(--mantine-color-gray-4)`,
                }}
                c={"gray.7"}
                wrap={"nowrap"}
                fw={600}
                gap={4}
                py={8}
                px={12}
                ta={"right"}
              >
                <Group>
                  {isLinkedin ? <IconUserPlus /> : <IconEye />}

                  <NumberFormatter value={opens} thousandSeparator=" " />
                </Group>
                {isUnique && <Text size="md">{lang.reports.unique}</Text>}
              </Stack>
            </Tooltip>
          )}

          {withClicks && (
            <Tooltip label={lang.reports.clicks}>
              <Stack
                align="center"
                flex={"1 1 auto"}
                fz={18}
                style={{
                  borderRadius: 12,
                  border: `1px solid var(--mantine-color-gray-4)`,
                }}
                c={"gray.7"}
                wrap={"nowrap"}
                fw={600}
                gap={4}
                py={8}
                px={12}
                ta={"right"}
              >
                <Group>
                  <IconClick />

                  <NumberFormatter value={clicks} thousandSeparator=" " />
                </Group>
                {isUnique && <Text size="md">{lang.reports.unique}</Text>}
              </Stack>
            </Tooltip>
          )}
        </Group>
      </Stack>

      {withRate && (
        <Group justify="end" wrap="nowrap">
          <ReportingInfo>
            <Text mb={-12}>{lang.reports.scale}:</Text>
            <ul style={{ paddingLeft: 16 }}>
              <li>
                <Text c={handleConclusion(1)}>
                  0% - 2% : {lang.reports.weak}
                </Text>
              </li>
              <li>
                <Text c={handleConclusion(2)}>
                  2% - 5% : {lang.reports.average}
                </Text>
              </li>
              <li>
                <Text c={handleConclusion(7)}>
                  {"> 5%"} : {lang.reports.excellent}
                </Text>
              </li>
            </ul>
          </ReportingInfo>
          <Text size="md">{lang.reports.answers_rate}</Text>
          <RingProgress
            mt={16}
            label={
              <Group justify="center" ml={16} mt={-8}>
                <Text size="lg" fw={600} ta="center">
                  {rate.toFixed(1)}%
                </Text>
              </Group>
            }
            roundCaps={rate < 92}
            sections={[{ value: rate, color: handleConclusion(rate) }]}
            styles={
              {
                // curve: {
                //   stroke: "red"
                // }
              }
            }
          />
        </Group>
      )}
    </Paper>
  );
};

export default TypeSummary;
